import Vue from 'vue';
import { TranslationSupport } from '@/scripts/libs/page-loader/translation-support';
import PartnerLocale from '../locale.json';
import { MiniTranslator } from '@/scripts/helpers/mini-translator';

const translationInstance = new MiniTranslator(PartnerLocale);

const translationSupport = new TranslationSupport(translationInstance);

export const i18nComponent = Vue.extend({
  mixins: [
    translationSupport.setup('$t'),
  ],
});

export const JoinBaseComponent = i18nComponent.extend({});
